'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge, Button, DropdownMenu, IconButton, Tooltip } from '@/shared/components/ui';
import { formatCurrency, formatDateEuropean } from '@/shared/formatters';
import { isSituacaoAguardandoPagamento, isSituacaoPagamentoVencido, situacaoBadgeVariant } from '@/shared/utils/situacaoProcessoArbitral';
import * as SubframeCore from '@subframe/core';
import { FeatherAlertTriangle, FeatherChevronLeft, FeatherClock, FeatherDownload, FeatherEdit2, FeatherInfo, FeatherMoreVertical, FeatherPlusCircle, FeatherRotateCcw, FeatherX } from '@subframe/core';
import type { ProcessoArbitralDetail } from '../types/arbitralDetailTypes';
import { getStatusDescription, getStatusLabel, getStatusVariant, isProcessoArbitralEncerrado } from '../utils/arbitralDetailUtils';
interface ArbitralDetailHeaderProps {
  processo: ProcessoArbitralDetail;
  pendenciasAtivasCount: number;
  onBackToList: () => void;
  onAddAndamento: () => void;
  onExportHistory: () => void;
  exportandoHistorico: boolean;
  esconderRegistrarAndamento: boolean;
  onEditarDados: () => void;
  onCancelProcess: () => void;
  onReabrir?: () => void;
  podeCancelarDireto: boolean;
  cancelamentoSolicitado: boolean;
  dadosSolicitados: boolean;
  podeCancelarProcesso: boolean;
  podeEditarIdentificacao: boolean;
  /** Menu + painel de "Baixar processo". Slot para o header não conhecer o store daquela feature. */
  acaoBaixarProcesso?: React.ReactNode;
}
export function ArbitralDetailHeader(t0) {
  const $ = _c(82);
  const {
    processo,
    pendenciasAtivasCount,
    onBackToList,
    onAddAndamento,
    onExportHistory,
    exportandoHistorico,
    esconderRegistrarAndamento,
    onEditarDados,
    onCancelProcess,
    onReabrir,
    podeCancelarDireto,
    cancelamentoSolicitado,
    dadosSolicitados,
    podeCancelarProcesso,
    podeEditarIdentificacao,
    acaoBaixarProcesso
  } = t0;
  let t1;
  if ($[0] !== processo.status) {
    t1 = isProcessoArbitralEncerrado(processo.status);
    $[0] = processo.status;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isClosed = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeatherChevronLeft className="h-3.5 w-3.5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onBackToList) {
    t3 = <button onClick={onBackToList} className="text-subtext-color hover:text-brand-600 mb-2 flex w-fit items-center gap-1.5 text-sm transition">{t2}Processos</button>;
    $[3] = onBackToList;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== processo.codigo) {
    t4 = <h1 className="text-default-font font-mono text-3xl font-semibold tracking-[-0.01em]">{processo.codigo}</h1>;
    $[5] = processo.codigo;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex min-w-0 flex-col">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== acaoBaixarProcesso || $[11] !== cancelamentoSolicitado || $[12] !== dadosSolicitados || $[13] !== esconderRegistrarAndamento || $[14] !== exportandoHistorico || $[15] !== isClosed || $[16] !== onAddAndamento || $[17] !== onCancelProcess || $[18] !== onEditarDados || $[19] !== onExportHistory || $[20] !== podeCancelarDireto || $[21] !== podeCancelarProcesso || $[22] !== podeEditarIdentificacao) {
    t6 = !isClosed && <div className="flex flex-shrink-0 items-center gap-2 pt-0.5">{acaoBaixarProcesso}{!esconderRegistrarAndamento && <Button variant="brand-primary" icon={<FeatherPlusCircle />} size="medium" onClick={onAddAndamento}>Registrar andamento</Button>}<SubframeCore.DropdownMenu.Root><SubframeCore.DropdownMenu.Trigger asChild={true}><IconButton variant="neutral-secondary" icon={<FeatherMoreVertical />} /></SubframeCore.DropdownMenu.Trigger><SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content align="end" className="animate-fade-in w-72"><DropdownMenu><DropdownMenu.DropdownItem icon={<FeatherDownload />} onClick={onExportHistory} disabled={exportandoHistorico}>Exportar histórico</DropdownMenu.DropdownItem>{podeEditarIdentificacao && !dadosSolicitados && <><SubframeCore.DropdownMenu.Separator className="my-1 border-neutral-100" /><DropdownMenu.DropdownItem icon={<FeatherEdit2 />} onClick={onEditarDados}>Solicitar alteração dos dados</DropdownMenu.DropdownItem></>}{podeCancelarProcesso && !cancelamentoSolicitado && <><SubframeCore.DropdownMenu.Separator className="my-1 border-neutral-100" /><DropdownMenu.DropdownItem icon={<FeatherX className="text-error-600" />} onClick={onCancelProcess}><span className="text-error-600">{podeCancelarDireto ? "Cancelar processo" : "Solicitar cancelamento"}</span></DropdownMenu.DropdownItem></>}</DropdownMenu></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal></SubframeCore.DropdownMenu.Root></div>;
    $[10] = acaoBaixarProcesso;
    $[11] = cancelamentoSolicitado;
    $[12] = dadosSolicitados;
    $[13] = esconderRegistrarAndamento;
    $[14] = exportandoHistorico;
    $[15] = isClosed;
    $[16] = onAddAndamento;
    $[17] = onCancelProcess;
    $[18] = onEditarDados;
    $[19] = onExportHistory;
    $[20] = podeCancelarDireto;
    $[21] = podeCancelarProcesso;
    $[22] = podeEditarIdentificacao;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== acaoBaixarProcesso || $[25] !== exportandoHistorico || $[26] !== isClosed || $[27] !== onExportHistory || $[28] !== onReabrir) {
    t7 = isClosed && <div className="flex flex-shrink-0 items-center gap-2 pt-0.5">{acaoBaixarProcesso}<Button variant="neutral-secondary" icon={<FeatherDownload />} size="medium" onClick={onExportHistory} loading={exportandoHistorico} disabled={exportandoHistorico}>Exportar histórico</Button>{onReabrir && <Button variant="brand-primary" icon={<FeatherRotateCcw />} size="medium" onClick={onReabrir}>Reabrir processo</Button>}</div>;
    $[24] = acaoBaixarProcesso;
    $[25] = exportandoHistorico;
    $[26] = isClosed;
    $[27] = onExportHistory;
    $[28] = onReabrir;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== t5 || $[31] !== t6 || $[32] !== t7) {
    t8 = <div className="flex w-full items-start justify-between gap-6">{t5}{t6}{t7}</div>;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== processo.status) {
    t9 = getStatusVariant(processo.status);
    $[34] = processo.status;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== processo.status) {
    t10 = getStatusLabel(processo.status);
    $[36] = processo.status;
    $[37] = t10;
  } else {
    t10 = $[37];
  }
  let t11;
  if ($[38] !== t10 || $[39] !== t9) {
    t11 = <Badge variant={t9}>{t10}</Badge>;
    $[38] = t10;
    $[39] = t9;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SubframeCore.Tooltip.Trigger asChild={true}><FeatherInfo className="h-3.5 w-3.5 cursor-help text-neutral-400" /></SubframeCore.Tooltip.Trigger>;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== processo.status) {
    t13 = getStatusDescription(processo.status);
    $[42] = processo.status;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== t13) {
    t14 = <SubframeCore.Tooltip.Provider><SubframeCore.Tooltip.Root>{t12}<SubframeCore.Tooltip.Portal><SubframeCore.Tooltip.Content side="bottom" align="start" sideOffset={4} asChild={true}><Tooltip>{t13}</Tooltip></SubframeCore.Tooltip.Content></SubframeCore.Tooltip.Portal></SubframeCore.Tooltip.Root></SubframeCore.Tooltip.Provider>;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== isClosed || $[47] !== pendenciasAtivasCount) {
    t15 = pendenciasAtivasCount > 0 && !isClosed && <Badge variant="warning">{pendenciasAtivasCount} {pendenciasAtivasCount === 1 ? "pend\xEAncia" : "pend\xEAncias"}</Badge>;
    $[46] = isClosed;
    $[47] = pendenciasAtivasCount;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== processo.situacoes) {
    t16 = processo.situacoes ?? [];
    $[49] = processo.situacoes;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== t16) {
    t17 = t16.map(_temp);
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== dadosSolicitados) {
    t18 = dadosSolicitados && <Badge variant="warning"><span className="flex items-center gap-1"><FeatherClock className="h-3 w-3" />Alteração dos dados solicitada</span></Badge>;
    $[53] = dadosSolicitados;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] !== cancelamentoSolicitado) {
    t19 = cancelamentoSolicitado && <Badge variant="warning"><span className="flex items-center gap-1"><FeatherClock className="h-3 w-3" />Cancelamento solicitado</span></Badge>;
    $[55] = cancelamentoSolicitado;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="h-1 w-1 rounded-full bg-neutral-300" />;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== processo.dataAbertura) {
    t21 = formatDateEuropean(processo.dataAbertura);
    $[58] = processo.dataAbertura;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== t21) {
    t22 = <span className="text-subtext-color text-sm">{t21}</span>;
    $[60] = t21;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span className="h-1 w-1 rounded-full bg-neutral-300" />;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== processo.valorCausa) {
    t24 = formatCurrency(processo.valorCausa);
    $[63] = processo.valorCausa;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] !== t24) {
    t25 = <span className="text-default-font text-sm font-medium">{t24}</span>;
    $[65] = t24;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  let t26;
  if ($[67] !== t11 || $[68] !== t14 || $[69] !== t15 || $[70] !== t17 || $[71] !== t18 || $[72] !== t19 || $[73] !== t22 || $[74] !== t25) {
    t26 = <div className="-mt-1 flex flex-wrap items-center gap-2.5">{t11}{t14}{t15}{t17}{t18}{t19}{t20}{t22}{t23}{t25}</div>;
    $[67] = t11;
    $[68] = t14;
    $[69] = t15;
    $[70] = t17;
    $[71] = t18;
    $[72] = t19;
    $[73] = t22;
    $[74] = t25;
    $[75] = t26;
  } else {
    t26 = $[75];
  }
  let t27;
  if ($[76] !== processo.partes) {
    t27 = processo.partes.some(_temp2) && <div className="border-error-400 flex items-center gap-2 border-l-2 border-solid bg-white py-0.5 pl-3"><FeatherAlertTriangle className="text-error-500 h-3.5 w-3.5 flex-shrink-0" /><span className="text-caption text-error-600">Contato inválido em uma ou mais partes — verifique a aba Visão geral.</span></div>;
    $[76] = processo.partes;
    $[77] = t27;
  } else {
    t27 = $[77];
  }
  let t28;
  if ($[78] !== t26 || $[79] !== t27 || $[80] !== t8) {
    t28 = <div className="flex w-full flex-col gap-4">{t8}{t26}{t27}</div>;
    $[78] = t26;
    $[79] = t27;
    $[80] = t8;
    $[81] = t28;
  } else {
    t28 = $[81];
  }
  return t28;
}
function _temp2(p) {
  return p.contatoInvalido;
}
function _temp(s) {
  return <Badge key={s.id} variant={situacaoBadgeVariant(s.key)}>{isSituacaoAguardandoPagamento(s.key) || isSituacaoPagamentoVencido(s.key) ? <span className="flex items-center gap-1"><FeatherClock className="h-3 w-3" />{s.label}</span> : s.label}</Badge>;
}